import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    confirmationDialog: {
      "& .MuiDialogTitle-root": {
        maxHeight: 56
      },
      "& .MuiPaper-root": {
        maxWidth: 300
      },
      "& .MuiDialogContent-root, & .MuiDialogTitle-root": {
        paddingLeft: 20,
        paddingRight: 20
      },
      "& .MuiDialogContent-root": {
        paddingTop: 0,
        paddingBottom: 16
      },
      "& .MuiDialogActions-root": {
        paddingTop: 0,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 10
      }
    },
    dialogTitle: {
      fontSize: 20,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "normal",
      color: primary.main
    },
    dialogContentText: {
      fontSize: 14,
      color: primary.dark,
      lineHeight: "19px"
    },
    textTitle: {
      fontSize: 12,
      color: theme.palette.text.secondary,
      paddingTop: 16
    },
    text: {
      fontSize: 14,
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    decisions: {
      flexGrow: 1,
      textAlign: "right"
    },
    button: {
      fontSize: 16,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    undo: {
      color: secondary.dark
    },
    cancel: {
      color: primary.dark
    }
  };
});
